export default "__VITE_ASSET__CgFh3p0v__"